import { render } from "./staff-attendance.vue?vue&type=template&id=bc61b56a"
import script from "./staff-attendance.vue?vue&type=script&lang=js"
export * from "./staff-attendance.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__